import { AccredibleButtonComponentModule } from '@accredible-frontend-v2/new-components/button';
import { AccredibleIconComponentModule } from '@accredible-frontend-v2/new-components/icon';
import {
  AccredibleResponsiveBreakpoint,
  AccredibleResponsiveHelper,
} from '@accredible-frontend-v2/utils/responsive-helper';
import { ChangeDetectionStrategy, Component, OnInit, input, signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  standalone: true,
  selector: 'accredible-open-directory-btn',
  templateUrl: `./open-directory-btn.component.html`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, AccredibleButtonComponentModule, AccredibleIconComponentModule],
  host: {
    '(window:resize)': 'onResize()',
  },
})
export class OpenDirectoryButtonComponent implements OnInit {
  disabled = input<boolean>();
  directoryUrl = input<string>();

  isMobile = signal<boolean>(false);

  onResize(): void {
    this._detectMobileVersion();
  }

  ngOnInit(): void {
    this._detectMobileVersion();
  }

  private _detectMobileVersion(): void {
    this.isMobile.set(
      AccredibleResponsiveHelper.isScreenLessThan(AccredibleResponsiveBreakpoint.XS),
    );
  }
}
